import React from 'react';
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

/**
 * Enhanced error message component to display error messages from backend responses
 * @param {Object} props - Component props
 * @param {string|Object} props.message - Error message or error object from backend
 * @param {Function} props.onDismiss - Function to dismiss the error
 * @param {ReactNode} props.children - Optional child elements to render
 */
const ErrorMessage = ({ message, onDismiss, children }) => {
  if (!message) return null;
  
  // Extract message from different error formats
  let displayMessage = '';
  
  if (typeof message === 'string') {
    displayMessage = message;
  } else if (typeof message === 'object') {
    if (message.message) {
      displayMessage = message.message;
    } else if (message.status && typeof message.status === 'string' && message.status.includes(':')) {
      // Handle error format like "FEHLER_022: Error message"
      displayMessage = message.status.split(':')[1].trim();
    } else {
      displayMessage = 'Ein unerwarteter Fehler ist aufgetreten';
    }
  } else {
    displayMessage = 'Ein unerwarteter Fehler ist aufgetreten';
  }
  
  return (
    <Alert 
      variant="danger" 
      dismissible={!!onDismiss}
      onClose={onDismiss}
      className="d-flex align-items-center"
    >
      <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" size="lg" />
      <div>
        {displayMessage}
        {children}
      </div>
    </Alert>
  );
};

export default ErrorMessage;